import { ref as databaseRef } from 'firebase/database';
import { useObjectVal } from 'react-firebase-hooks/database';

import { selectAuth } from '@/features/auth';
import { useAppSelector } from '@/hooks';
import { getFirebaseDatabase } from '@/providers/firebase';

import {
  type PaymentMethod,
  PaymentMethodSchema,
} from '../types/payment-method';

const validatePaymentMethod = (
  paymentMethod: unknown,
): PaymentMethod | null => {
  const parsedPaymentMethod = PaymentMethodSchema.safeParse(paymentMethod);

  if (!parsedPaymentMethod.success) {
    return null;
  }

  return parsedPaymentMethod.data;
};

export function usePaymentMethod(): {
  data: PaymentMethod | null;
  loading: boolean;
  error: Error | undefined;
} {
  const auth = useAppSelector(selectAuth);

  const [value, loading, error] = useObjectVal<string>(
    databaseRef(
      getFirebaseDatabase(),
      auth.user !== null ? `${auth.user.uid}/paymentMethod` : undefined,
    ),
  );

  const transformedValue: PaymentMethod | null = validatePaymentMethod(value);

  return {
    data: transformedValue,
    loading,
    error,
  };
}
